module.exports = __webpack_public_path__ + "static/media/rsz_2golf.8169d322.png";